import { DollarSign, Euro, PoundSterling, IndianRupee, JapaneseYen, Percent } from "lucide-react";

export const formatCost = (cost, currency, basis) => {
  if (basis === 'PERCENTAGE') {
    return (
      <>
        {cost}<Percent size={16} className="ml-1 mr-2" />({basis})
      </>
    );
  }

  const getCurrencySymbol = (currency) => {
    switch (currency) {
      case 'USD':
        return <DollarSign size={16} className="mr-1" />;
      case 'EUR':
        return <Euro size={16} className="mr-1" />;
      case 'GBP':
        return <PoundSterling size={16} className="mr-1" />;
      case 'INR':
        return <IndianRupee size={16} className="mr-1" />;
      case 'JPY':
        return <JapaneseYen size={16} className="mr-1" />;
      default:
        return null;
    }
  };

  const currencySymbol = getCurrencySymbol(currency);
  return basis ? (
    <>
      {currencySymbol}
      {cost} {currency} ({basis})
    </>
  ) : (
    <>
      {currencySymbol}
      {cost} {currency}
    </>
  );
};